export const optionPresetGroupKeys = {
    root: ['optionPresetGroups'] as const,
    list: (projectId: number) => [...optionPresetGroupKeys.root, 'list', projectId] as const,
    withItems: (projectId: number) => [...optionPresetGroupKeys.root, 'withItems', projectId] as const,
    matrix: (presetGroupId: number) => [...optionPresetGroupKeys.root, 'matrix', presetGroupId] as const,
};
